module.exports = __webpack_public_path__ + "static/media/38_tn.daaf7a70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/38_tn.jpg
// module id = 347
// module chunks = 0